var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex mt-2" },
    [
      _vm.previewOnlyWithLink
        ? _c("div", { staticClass: "d-flex" }, [
            _vm.file.url
              ? _c(
                  "a",
                  {
                    staticClass: "preview-pdf",
                    attrs: {
                      href: _vm.openLinkFileInModal ? null : _vm.file.url,
                      target: "_blank"
                    },
                    on: {
                      click: function($event) {
                        _vm.openLinkFileInModal
                          ? _vm.askOpenImageLinkInModal(_vm.file.url)
                          : null
                      }
                    }
                  },
                  [_vm._v("\n      " + _vm._s(_vm.file.fileName) + "\n    ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.file.url
              ? _c(
                  "button",
                  {
                    staticClass:
                      "action-btn delete cursor-pointer ml-2 delete-action-btn-pdf",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.deleteFile($event)
                      }
                    }
                  },
                  [_c("i", { staticClass: "ph-custom ph-trash-bold" })]
                )
              : _vm._e()
          ])
        : _vm.imagePreviewSrc || _vm.showImgFromUrl
        ? _c("div", { staticClass: "item-preview-one-file" }, [
            _c("div", { staticClass: "img-preview-one-file-container" }, [
              _c("img", {
                staticClass: "img-preview-one-file cursor-pointer",
                attrs: {
                  src: _vm.imagePreviewSrc ? _vm.imagePreviewSrc : _vm.file.url,
                  alt: "Image"
                },
                on: {
                  click: function($event) {
                    return _vm.openModal(
                      _vm.imagePreviewSrc ? _vm.imagePreviewSrc : _vm.file.url
                    )
                  }
                }
              }),
              _vm._v(" "),
              _vm.showDelete
                ? _c("div", { staticClass: "delete-btn-container" }, [
                    _c(
                      "button",
                      {
                        staticClass: "action-btn delete cursor-pointer",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.deleteFile($event)
                          }
                        }
                      },
                      [_c("i", { staticClass: "ph-custom ph-trash-bold" })]
                    )
                  ])
                : _vm._e()
            ])
          ])
        : _vm.pdfPreviewSrc || _vm.showPdfFromUrl
        ? _c("div", { staticClass: "d-flex" }, [
            _vm.pdfPreviewSrc
              ? _c(
                  "a",
                  {
                    staticClass: "preview-pdf",
                    attrs: { target: "_blank" },
                    on: {
                      click: function($event) {
                        return _vm.openLoadedPdfInNewWindow(_vm.pdfPreviewSrc)
                      }
                    }
                  },
                  [_vm._v("\n      " + _vm._s(_vm.file.fileName) + "\n    ")]
                )
              : _vm.showPdfFromUrl
              ? _c(
                  "a",
                  {
                    staticClass: "preview-pdf",
                    attrs: { href: _vm.file.url, target: "_blank" }
                  },
                  [_vm._v("\n      " + _vm._s(_vm.file.fileName) + "\n    ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "action-btn delete cursor-pointer ml-2 delete-action-btn-pdf",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.deleteFile($event)
                  }
                }
              },
              [_c("i", { staticClass: "ph-custom ph-trash-bold" })]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            "hide-footer": "",
            centered: "",
            size: "lg",
            "hide-backdrop": "",
            "content-class": "p-0"
          },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function() {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button", "aria-label": "Close" },
                      on: {
                        click: function($event) {
                          _vm.showModal = false
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "ph-custom ph-x-bold secondary-text-color"
                      })
                    ]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.showModal,
            callback: function($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal"
          }
        },
        [
          _vm._v(" "),
          _c("img", {
            staticClass: "w-100",
            attrs: { src: _vm.selectedImageUrl, alt: "Image agrandie" }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-669e8c63", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-669e8c63","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/b122/showFields/PreviewOneFile.vue
// module id = OQFj
// module chunks = 0